export const EnvironmentVariable = {
  localEnvConfig: {
    API_URL: "https://menupos-be-dev-737182173340.europe-west3.run.app",
  },
} as const;

/**
 * Where a guest is sent to actually pay.
 *
 * Neither the order nor the tip endpoint charges anything: each creates a Viva
 * payment order and hands back an `orderCode`, and the guest completes the
 * payment on Viva's own checkout. Which host issued that code is decided by
 * the backend's VIVA_API_URL, and no API response says which, so it is set
 * here. This is the demo host, matching the -dev backend above. SWITCH BOTH
 * TOGETHER when pointing at production.
 */
export const VIVA_CHECKOUT_URL = "https://demo.vivapayments.com/web/checkout";

export const FeatureFlag = {
  /**
   * Everything the guest app needs now exists on the backend, so nothing here
   * runs against a mock. Left in place as a switch: flipping one back is how
   * you demo a flow whose endpoint is down.
   *
   * POST /public/restaurants/:restaurantId/orders
   */
  USE_MOCK_ORDERS: false,

  /** GET /public/restaurants/:restaurantId/waiters */
  USE_MOCK_WAITERS: false,

  /** POST /public/restaurants/:restaurantId/tips */
  USE_MOCK_TIPS: false,
} as const;
